try {
	let sourceWindow = location.protocol === 'about:' ? window.parent : window;
	let url = sourceWindow.location.origin + sourceWindow.location.pathname.replace(/\/[^/]*$/, '/');

	// eslint-disable-next-line no-undef
	__webpack_public_path__ = url + (window.__RELATIVE_ROOT__ || '');
} catch (e) {}